/**
 * @file LlmIcon.tsx
 * @description LLM 头像圆形图标（使用传入颜色作为背景），用于机器人消息头像显示。
 */
const LlmIcon = ({ avatarColor }: { avatarColor: string }) => {
  return (
    <div className="flex h-6 w-6 min-w-6 items-center justify-center rounded-full" style={{ background: avatarColor }}>
      {/* <AvatarIcon /> */}
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="12" fill="#111111" />
        <path
          d="M11.9971 14.5513C10.5787 14.5599 9.40607 13.3735 9.40527 11.9296C9.40448 10.493 10.5521 9.32992 11.9884 9.3122C13.402 9.29475 14.5861 10.4865 14.5866 11.9275C14.5871 13.3738 13.4336 14.5427 11.9969 14.5513H11.9971ZM12.0131 10.1346C11.0449 10.1201 10.2375 10.9182 10.219 11.9081C10.2004 12.8918 10.9976 13.7172 11.9791 13.73C12.9547 13.7427 13.7634 12.9369 13.7734 11.9425C13.7833 10.9628 12.9911 10.1493 12.0131 10.1348V10.1346Z"
          fill="white"
        />
        <path
          d="M12.114 6C13.3151 6.01665 14.5442 6.44756 15.6205 7.31582C15.7933 7.45516 15.8432 7.64659 15.7612 7.82862C15.686 7.99507 15.5039 8.09951 15.3253 8.05817C15.2427 8.0391 15.1601 7.99293 15.0927 7.9395C14.0701 7.13191 12.911 6.75765 11.6171 6.83497C10.5822 6.89672 9.6528 7.25675 8.8322 7.90003C8.80433 7.92205 8.77698 7.94487 8.74831 7.96581C8.54097 8.11884 8.30337 8.09575 8.15762 7.90889C8.01347 7.72418 8.04055 7.46509 8.24948 7.31931C8.59779 7.07607 8.94583 6.82531 9.31989 6.62771C10.1373 6.19626 11.0184 6.00161 12.114 6Z"
          fill="white"
        />
        <path
          d="M17.8601 12.57C17.795 13.1975 17.6419 13.8023 17.3798 14.375C16.7947 15.6541 15.8844 16.6195 14.6348 17.2518C14.4346 17.353 14.2315 17.3165 14.1068 17.1589C13.9841 17.004 13.9799 16.7873 14.1107 16.6407C14.1652 16.5798 14.2411 16.5341 14.3144 16.4955C14.6966 16.2941 15.055 16.0584 15.3755 15.7663C16.3155 14.9088 16.8765 13.848 17.0406 12.5759C17.0751 12.3085 17.2128 12.1563 17.4311 12.1456C17.6724 12.1335 17.8667 12.326 17.8601 12.57Z"
          fill="white"
        />
        <path
          d="M9.56085 17.3214C9.4905 17.2973 9.41564 17.282 9.35059 17.2479C7.66056 16.3608 6.6098 14.9779 6.21052 13.0931C6.17999 12.9492 6.16114 12.8026 6.13991 12.6566C6.10194 12.3962 6.24397 12.1827 6.47467 12.1497C6.71759 12.1151 6.91404 12.2756 6.94669 12.5438C7.01651 13.1213 7.17049 13.673 7.42907 14.1942C7.91117 15.1663 8.61867 15.9183 9.56722 16.4352C9.64501 16.4776 9.72598 16.5154 9.79925 16.5646C9.94819 16.6642 10.0116 16.8583 9.95641 17.0247C9.89721 17.2028 9.74748 17.3118 9.56085 17.3214Z"
          fill="white"
        />
        <path
          d="M6.5468 9.72908C6.85475 9.73418 7.0905 9.98037 7.0836 10.2897C7.07696 10.5904 6.83166 10.8285 6.53273 10.8245C6.22849 10.8207 5.99036 10.5708 5.9962 10.2617C6.00204 9.9597 6.24548 9.72424 6.5468 9.72908Z"
          fill="white"
        />
        <path
          d="M17.4581 9.729C17.7602 9.73223 17.9968 9.97225 17.996 10.2751C17.9952 10.5828 17.7504 10.8279 17.4462 10.8257C17.1443 10.8236 16.9022 10.5704 16.9083 10.2633C16.9142 9.96151 17.1565 9.72605 17.4581 9.72927V9.729Z"
          fill="white"
        />
        <path
          d="M12.0003 17.9998C11.7001 18.0025 11.4577 17.7647 11.4532 17.4629C11.4487 17.1541 11.6863 16.9077 11.9929 16.9034C12.2886 16.8993 12.5347 17.1415 12.5406 17.4419C12.5467 17.7493 12.3067 17.9969 12.0001 17.9998H12.0003Z"
          fill="white"
        />
      </svg>
    </div>
  )
}

export default LlmIcon
